import React, {Component} from 'react';
import {Map, InfoWindow, Marker, GoogleApiWrapper, Polyline} from 'google-maps-react';
import { helperMultisort } from '../../../../services/utils'

export class MapContainerTrakingApp extends Component {

  render() {
    console.log(this.props.activity);

    if(this.props.activity == undefined){
      return <div></div>
    }
    var activityData = Object.values(this.props.activity);

    activityData = helperMultisort(activityData, ["timestamp"], ["ASC"]);
    console.log(activityData);

    const coords = [];
    var startLat = activityData[0].coords.latitude;
    var startLng = activityData[0].coords.longitude;

    for (var i in activityData){
      if(activityData[i].coords.latitude){
        coords.push({lat: activityData[i].coords.latitude, lng: activityData[i].coords.longitude});
      }
    }
    return (
      <div style={{height:400, width:800}}>
      <Map containerStyle={{ position: 'relative', width: '100%', height: '100%'}} 
      google={this.props.google} zoom={16}
      initialCenter={{
        lat: startLat,
        lng: startLng
      }}>
      <Polyline
          path={coords}
          strokeColor="#0000FF"
          strokeOpacity={0.8}
          strokeWeight={2} />
 <Marker
    name={'Inicio'}
    position={{lat: startLat, lng: startLng}} />
      
        <InfoWindow onClose={this.onInfoWindowClose}>
            <div>
              <h1>Prueba</h1>
            </div>
        </InfoWindow>
      </Map>
      </div>
    );
  }
}
 
export default GoogleApiWrapper({
  apiKey: ("AIzaSyAtcbYiS6l_5yaNkACPUyvK8CcoIENc3Vk")
})(MapContainerTrakingApp)
